import { ContentTransformTypes } from '../../Enums/ContentTransformTypes';

export type ContentTransformParams =
    | {
          type:
              | ContentTransformTypes.CONTAIN
              | ContentTransformTypes.COVER
              | ContentTransformTypes.COVER_WIDTH
              | ContentTransformTypes.COVER_HEIGHT
              | ContentTransformTypes.TEXT;
          horizontalAlignment: number;
          verticalAlignment: number;
          scale?: number;
          horizontalOffset?: number;
          verticalOffset?: number;
          locked?: boolean;
      }
    | {
          type: ContentTransformTypes.FREE;
          horizontalOffset: number;
          verticalOffset: number;
          scale: number;
          locked?: boolean;
      };

export class ContentTransform {
    type: ContentTransformTypes;

    horizontalAlignment: number;

    verticalAlignment: number;

    horizontalOffset: number;

    verticalOffset: number;

    scale: number;

    locked: boolean;

    private _hasManualScale: boolean;

    constructor(params: ContentTransformParams) {
        this.type = params.type;
        this.locked = params.locked ?? false;

        if (params.type === ContentTransformTypes.FREE) {
            this.horizontalAlignment = 0;
            this.verticalAlignment = 0;
            this.horizontalOffset = params.horizontalOffset;
            this.verticalOffset = params.verticalOffset;
            this.scale = params.scale;
            this._hasManualScale = true;
        } else {
            this.horizontalAlignment = params.horizontalAlignment;
            this.verticalAlignment = params.verticalAlignment;
            this.horizontalOffset = params.horizontalOffset ?? 0;
            this.verticalOffset = params.verticalOffset ?? 0;
            this.scale = params.scale ?? 1;
            this._hasManualScale = params.scale !== undefined;
        }
    }

    hasManualScale(): boolean {
        return this._hasManualScale;
    }

    getType(): ContentTransformTypes {
        return this.type;
    }

    getHorizontalAlignment(): number {
        return this.horizontalAlignment;
    }

    getVerticalAlignment(): number {
        return this.verticalAlignment;
    }

    getHorizontalOffset(): number {
        return this.horizontalOffset;
    }

    getVerticalOffset(): number {
        return this.verticalOffset;
    }

    getScale(): number {
        return this.scale;
    }

    getLocked(): boolean {
        return this.locked;
    }

    toObject(): ContentTransformParams {
        if (this.type === ContentTransformTypes.FREE) {
            return {
                type: this.type,
                horizontalOffset: this.horizontalOffset,
                verticalOffset: this.verticalOffset,
                scale: this.scale,
                locked: this.locked,
            };
        } else {
            const obj: {
                type: Exclude<ContentTransformTypes, ContentTransformTypes.FREE>;
                horizontalAlignment: number;
                verticalAlignment: number;
                scale?: number;
                horizontalOffset?: number;
                verticalOffset?: number;
                locked: boolean;
            } = {
                type: this.type,
                horizontalAlignment: this.horizontalAlignment,
                verticalAlignment: this.verticalAlignment,
                locked: this.locked,
            };

            // Include scale if it's been manually set
            if (this._hasManualScale) {
                obj.scale = this.scale;
            }

            // Include offsets if they're been set (not the default 0)
            if (this.horizontalOffset !== 0) {
                obj.horizontalOffset = this.horizontalOffset;
            }

            if (this.verticalOffset !== 0) {
                obj.verticalOffset = this.verticalOffset;
            }

            return obj;
        }
    }
}
